var _g, _rect, _rect2, _g2, _g3, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 738,
    height: 805,
    viewBox: "0 0 738 805",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5500_503)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.91309,
    y: 6.07471,
    width: 724.718,
    height: 792.682,
    rx: 20,
    fill: "#1E1F22"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5500_503",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 726,
    height: 793
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.91309,
    y: 6.07471,
    width: 724.718,
    height: 792.682,
    rx: 20,
    fill: "#1E1F22"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5500_503)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5500_503",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -387,
    y: -152,
    width: 1688,
    height: 1228
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -386.192,
    y: -151.639,
    width: 1686.53,
    height: 1226.92,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5500_503)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1191.26 -149.561L2384.03 975.719L-1428.41 975.718L-235.64 -149.561L1191.26 -149.561Z",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1494 -149.561L-702.232 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.098 -149.561L-520.687 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.045 -149.561L-339.143 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.991 -149.561L-157.599 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.939 -149.561L23.9464 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.887 -149.561L205.491 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.834 -149.561L387.035 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.781 -149.561L568.58 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.728 -149.561L750.124 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.676 -149.561L931.669 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.624 -149.561L1113.21 975.719",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2016.53 629.014L-1060.91 629.014",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.61 541.359L-967.999 541.359",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.28 463.687L-885.668 463.687",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.82 394.385L-812.21 394.384",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.88 332.168L-746.26 332.168",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.34 276.003L-686.727 276.003",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.33 225.048L-632.716 225.048",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.11 178.61L-583.493 178.61",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1494.06 136.114L-538.449 136.114",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.69 97.0781L-497.072 97.078",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.55 61.0972L-458.932 61.0971",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.28 27.8252L-423.665 27.8251",
    stroke: "#645C5C",
    strokeOpacity: 0.5,
    strokeWidth: 0.8815,
    strokeLinejoin: "round"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_5500_503)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5500_503)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 671.224,
    y: 27.4451,
    width: 36.5549,
    height: 36.5549,
    rx: 5,
    fill: "#28292B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.724,
    y: 27.9451,
    width: 35.5549,
    height: 35.5549,
    rx: 4.5,
    stroke: "#9B9B9B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M696.539 48.0684V51.1961C696.539 51.6109 696.374 52.0087 696.081 52.3019C695.787 52.5952 695.39 52.76 694.975 52.76H684.028C683.613 52.76 683.215 52.5952 682.922 52.3019C682.629 52.0087 682.464 51.6109 682.464 51.1961V48.0684",
    stroke: "#A0A0A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M685.592 44.1587L689.501 48.0684L693.411 44.1587",
    stroke: "#A0A0A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M689.501 48.0683V38.6851",
    stroke: "#A0A0A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5500_503",
    x: 0.913086,
    y: 0.074707,
    width: 736.718,
    height: 804.682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5500_503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5500_503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_5500_503",
    x: 667.224,
    y: 23.4451,
    width: 44.5547,
    height: 44.5549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5500_503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5500_503",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5500_503"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5500_503",
    x: 665.224,
    y: 21.4451,
    width: 48.5547,
    height: 48.5549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5500_503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5500_503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1129.44,
    height: 3814,
    fill: "white",
    transform: "translate(2384.81 -151.639) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridImage);
export default __webpack_public_path__ + "static/media/gridImage.2a0e9aac4794941b9945eaf5c8665a89.svg";
export { ForwardRef as ReactComponent };